import React from "react";
import { render } from "react-dom";
import InputPhone from '~c/ui/InputPhone';
import routes from "~/apiRouter";
import PopupClose from '../Close';

const sendTimeout = 60;

function openErrorMsgForm (error) {
  $.magnificPopup.open({
    items: {
      src: '#popup',
    },
    closeOnBgClick: false,
    removalDelay: 250,
    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-anim';
      },
      open() {
        render(<ErrorSender error={error}/>, $('#popup')[0]);
      },
      close() {
        render(<div />, $('#popup')[0]);
      },
    },
  });
}

function getCookie(name) {
  const matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

class ThankYouMsg extends React.PureComponent {

  render(){
    document.cookie = `LAST_ERROR_SENDED=${new Date()}`;
    return(
      <div className="popup errorSender">
        <div className="popup__close-container"><PopupClose/></div>
        <p className="heading heading--2">Сообщение отправлено!</p>
        <p className="errorSender__msg">Специалисты Академии свяжутся с Вами в ближайшее время. Спасибо!</p>
        <form className="errorSender__form" action="/">
          <button className="btn btn--primary btn__back" type="submit">На главную</button>
        </form>
      </div>
    );
  }
}

class TimerMsg extends React.Component {
  state = {
    time: this.props.time,
    canSend: false,
    sendBtnPushed: false
  }

  componentDidMount(){
    setInterval(() => this.startTimer(), 1000);
  }

  startTimer(){
    if(this.state.time >= 1){
      this.setState({
        time: this.state.time - 1,
      });
    }else{
      this.setState({
        canSend: true,
      });
    }  
  }

  handleSend(e){
    e.preventDefault();
    this.setState({
      sendBtnPushed: true
    });
  }

  render(){
    const sendBtnClass = this.state.canSend ? 'btn btn--primary btn__back' : 'btn btn--disabled btn__back';

    if(this.state.sendBtnPushed){
      return <ErrorSender error={this.props.error}/>;
    }else{
      return(
        <div className="popup errorSender">
          <div className="popup__close-container"><PopupClose/></div>
          <p className="heading heading--2">Слишком часто</p>
          <p className="errorSender__msg">Недавно Вы уже отправляли сообщение об ошибке. Подождите {this.state.time} секунд, прежде чем отправить ещё одно</p>
          <form className="errorSender__form" action="/">
            <button className={sendBtnClass} type="submit" onClick={(e) => this.handleSend(e)}>Сообщить об ошибке</button>
            <button className="btn btn--primary btn__back" type="submit">На главную</button>
          </form>
        </div>
      );
    }
  }
}

export class ErrorSender extends React.Component {
  state = {
    email: '',
    emailValid: true,
    phone: '',
    errorUserMsg: '',
    errorSystemMsg: this.props.error,
    sended: false,
    timeToNextSend: 0
  }

  checkEmail(email) {
    const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    this.setState({
      emailValid: Boolean(regexp.test(email) || email === ''),
    });
  }

  handleEmailChange(e){
    this.setState({
      email: e.target.value
    });
    this.checkEmail(e.target.value);
  }

  handleMsgChange(e){
    this.setState({
      errorUserMsg: e.target.value
    });
  }

  handleSend(e){
    e.preventDefault();

    let timeToNextSend = 0;
    const lastErrorSended = getCookie('LAST_ERROR_SENDED');
    if (lastErrorSended !== undefined){
      timeToNextSend = Math.round(sendTimeout - (new Date() - new Date(lastErrorSended))/1000);
    }

    if(timeToNextSend < 1){
      const url = routes.user.errorlog;
      const options = {
        method: 'POST',
        credentials: 'include',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          email: this.state.email,
          phone: this.state.phone,
          errorUserMsg: this.state.errorUserMsg,
          errorSystemMsg: this.state.errorSystemMsg,
          date: new Date(),
          user: window.navigator.userAgent
        }),
      };

      fetch(url, options)
        .then(response => response.json());
        this.setState({
          sended: true,
          timeToNextSend: +timeToNextSend
        });
    }else{
      this.setState({
        timeToNextSend: +timeToNextSend
      });
    }
  }

  render(){
    const emailClass = `inp__field ${!this.state.emailValid ? 'inp__field--error' : ''}`;
    if(this.state.timeToNextSend > 0){
      return(<TimerMsg time={this.state.timeToNextSend} error={this.props.error}/>);
    }else if(this.state.sended){
      return (<ThankYouMsg/>);
    }else{
      return(
        <div className="popup errorSender">
          <div className="popup__close-container"><PopupClose/></div>
          <p className="heading heading--2">Сообщение об ошибке</p>
          <p className="errorSender__msg">При работе с сайтом возникла ошибка. Оставьте контактные данные и специалисты Академии с Вами свяжутся.</p>
          <form className="errorSender__form" action="/sendError">
          <label className="inp">
              <input autoСomplete="off" className={emailClass} type="email" placeholder={this.state.email || " "} onChange={(e) => this.handleEmailChange(e)}/>
              <p className="inp__label">E-mail</p>
            </label>
            <InputPhone
              value={this.state.phone}
              data-valid
              onChange={value => {
                this.setState({ phone: value });
              }}
              placeholder=" "
            >
              <p className="inp__label">Моб. телефон</p>
            </InputPhone>
            <label className="inp">
              <input autoСomplete="off" className="inp__field" type="text" placeholder=" " onChange={(e) => this.handleMsgChange(e)}/>
              <p className="inp__label">Опишите проблему</p>
            </label>
            <button className="btn btn--primary" type="submit" onClick={(e) => this.handleSend(e)}>Отправить</button>
          </form>
        </div>
      );
    }    
  }
}

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(errorObj) {
    const error = {
      errors: errorObj.message     
    };

    openErrorMsgForm(error);
  }

  render() {
    if (this.state.hasError) {
      return <h1>Что-то пошло не так.</h1>;
    }

    return this.props.children; 
  }
}

export default openErrorMsgForm;